export default "__VITE_ASSET__hQe6eu_H__"